<template>
    <div class="page-menu g3">
        <ul>
            <li class="head">Programs</li>
            <li><router-link :to="createLink('active')">Active</router-link></li>
            <li><router-link :to="createLink('archived')">Archived</router-link></li>
        </ul>
    </div>
</template>


<script>
    import { mapState } from 'vuex'

    export default {
        methods: {
            createLink(link) {
                return '/project/' + this.$route.params.id + '/' + link;
            }
        }
    }
</script>